import axios from "axios";
import { IApplicationNotification } from "./../utilities/interfaces";

export const urlApplicationNotifications =
  process.env.REACT_APP_BACKEND_BASE_URL + "/api/applications/notifications";

//Get Application Notifications Endpoint
export async function GetApplicationNotificationById(
  notificationId: number,
  token: string
) {
  let applicationNotification: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  await axios
    .get(
      `${urlApplicationNotifications}/applicationNotifications/${notificationId}`,
      config
    )
    .then((response) => {
      applicationNotification = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [applicationNotification, errors];
}

//Post Application Notifications Endpoint\
export async function PostApplicationNotification(
  applicationNotification: IApplicationNotification,
  token: string
) {
  let values: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios
    .post(
      urlApplicationNotifications + "/applicationNotification",
      applicationNotification,
      config
    )
    .then((response) => {
      values = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [values, errors];
}

//Delete Application Notifications Endpoint
export async function DeleteApplicationNotification(
  notificationId: number,
  token: string
) {
  let values: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios
    .delete(
      `${urlApplicationNotifications}/applicationNotification/${notificationId}`,
      config
    )
    .then((response) => {
      values = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [values, errors];
}

//Get Application User Notifications Endpoint
export async function GetApplicationUserNotificationStatus(
  userId: number,
  token: string
) {
  let applicationUserNotification: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  await axios
    .get(`${urlApplicationNotifications}/userNotifications/${userId}`, config)
    .then((response) => {
      applicationUserNotification = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [applicationUserNotification, errors];
}

//Post Application User Notifications Endpoint
export async function PostApplicationUserNotification(
  applicationNotification: IApplicationNotification,
  token: string
) {
  let values: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios
    .post(
      urlApplicationNotifications + "/userNotification",
      applicationNotification,
      config
    )
    .then((response) => {
      values = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [values, errors];
}

//Delete Application User Notificaitons Endpoint
export async function DeleteApplicationUserNotification(
  userNotificationStatusIds: number[],
  token: string
) {
  let values: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios
    .post(
      `${urlApplicationNotifications}/userNotification/delete`,
      userNotificationStatusIds,
      config
    )
    .then((response) => {
      values = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [values, errors];
}

//Delete All current user notifications given a userId
export async function DeleteAllApplicationUserNotificationsByUserId(
  userId: number,
  token: string
) {
  let values: any = null;
  let errors: any = null;
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  await axios
    .delete(
      `${urlApplicationNotifications}/userNotification/${userId}/wipeAll`,
      config
    )
    .then((response) => {
      values = response;
    })
    .catch((error) => {
      errors = error;
    });
  return [values, errors];
}
